import { render, staticRenderFns } from "./PolicyServices.vue?vue&type=template&id=e882b526&scoped=true&"
import script from "./PolicyServices.vue?vue&type=script&lang=js&"
export * from "./PolicyServices.vue?vue&type=script&lang=js&"
import style0 from "./PolicyServices.vue?vue&type=style&index=0&id=e882b526&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e882b526",
  null
  
)

export default component.exports